import _ from 'lodash-es';
import {ModulesType} from '../../enum';
import {Campaign} from '../index';
import {TixxConnect} from '../tixx-connect';
import {ApiConnection} from './api-connection';
import {FanScore} from './fan-score';
import {AuthClient} from './auth-client';
import {BasicStatusTranslationService, ProductSettingsTranslationService} from 'src/app/shared/translations';

/**
 * Blueprint for the module entity.
 */
export class Module {
  public id: number;
  public club: string;
  public name: string;
  public status: string;
  public configurable: boolean;
  public checked: boolean;

  public statuses: Array<any> = [
    { value: 'inactive', status: this.statusTranslations.i18nInactive },
    { value: 'active', status: this.statusTranslations.i18nActive },
  ];

  public setup: Array<any> = [
    { value: 'active', status: this.statusTranslations.i18nSetupComplete },
    { value: 'inactive', status: this.statusTranslations.i18nSetupIncomplete }
  ];

  public names: Array<any> = [
    { value: ModulesType.CAMPAIGN, name: this.productTranslations.campaign },
    { value: ModulesType.CRM_MEMBERSHIP, name: this.productTranslations.membership },
    { value: ModulesType.CAMPAI_MEMBERSHIP, name: this.productTranslations.campaiMembership },
    { value: ModulesType.MERCHANDISING, name: this.productTranslations.merchandising },
    { value: ModulesType.LOTTERY, name: this.productTranslations.tixxSelect },
    { value: ModulesType.TIXX_WEBSHOP, name: this.productTranslations.tixxWebshop },
    { value: ModulesType.CUSTOMER, name: this.productTranslations.customer },
    { value: ModulesType.EVENTIM_DATA_FEED, name: this.productTranslations.eventimDataFeed },
    { value: ModulesType.CUSTOMER_SCORE, name: this.productTranslations.fanScoreCard }
  ];

  constructor(
    module: any,
    private statusTranslations: BasicStatusTranslationService,
    private productTranslations: ProductSettingsTranslationService
  ) {
    this.id = module.id;
    this.club = module.club;
    this.name = module.name;
    this.status = module.status;
    this.configurable = module.configurable;
    this.checked = module.status === 'active' ? true : null;
    this.setConfiguration(module);
  }

  /**
   * Translates the status text
   */
  public get translatedStatus(): string {
    const translatedStatus = this.statuses.find(status => this.status === status.value);
    return translatedStatus?.status;
  }

  /**
   * Translates the setup text
   */
  public get translatedSetup(): string {
    const translatedSetup = this.setup.find(setup => this.status === setup.value);
    return translatedSetup?.status;
  }

  /**
   * Translates the status text
   */
  public get translatedName(): string {
    const translatedStatus = this.names.find(name => this.name === name.value);
    return translatedStatus?.name;
  }
  public apiConnection?: ApiConnection;
  public campaign?: Campaign;
  public tixxConnect?: TixxConnect;
  public setConfiguration(module) {
    switch (module.name) {
      case ModulesType.CUSTOMER_SCORE:
        _.merge(this, { customerScoreConfiguration: new FanScore(module.customerScoreConfiguration) });
        break;
      case ModulesType.INVOICE:
        _.merge(this, { tixxConnectApiConfiguration: new TixxConnect(module.tixxConnectApiConfiguration) });
        break;
      case ModulesType.CUSTOMER:
        _.merge(this, { tixxConnectApiConfiguration: new TixxConnect(module.tixxConnectApiConfiguration) });
        break;
      case ModulesType.TIXX_WEBSHOP:
        _.merge(this, { tixxWebshopConfiguration: module.tixxWebshopConfiguration });
        break;
      case ModulesType.LOTTERY:
        _.merge(this, {
          cleverReachConfiguration: new Campaign(module.cleverReachConfiguration),
          eventimOAuth2Configuration: new AuthClient(module.eventimOAuth2Configuration),
          tixxApiConfiguration: new ApiConnection(module.tixxApiConfiguration)
        });
        break;
      case ModulesType.CAMPAIGN:
        _.merge(this, { cleverReachConfiguration: new Campaign(module.cleverReachConfiguration) });
        break;
      case ModulesType.CAMPAI_MEMBERSHIP:
        _.merge(this, { campaiMembershipConfiguration: module.campaiMembershipConfiguration });
        break;
      default:
        break;
    }
  }

}
